var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"honour"},_vm._l((_vm.list),function(value,index){return _c('div',{key:index,staticClass:"box"},[_c('img',{attrs:{"src":value.img,"alt":""}}),_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(value.title)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }